<template>
  <div
    class="bg-white dark:bg-gray-900 min-h-screen px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8"
  >
    <div class="max-w-max mx-auto">
      <main class="sm:flex">
        <ParagraphText
          size="text-4xl sm:text-5xl"
          font="font-extrabold"
          color="text-indigo-600"
        >
          {{ status }}
        </ParagraphText>
        <div class="sm:ml-6">
          <div class="sm:border-l sm:border-gray-200 sm:pl-6">
            <TextBase
              is="h1"
              size="text-4xl sm:text-5xl"
              font="font-extrabold"
              color="text-gray-900"
              class="tracking-tight"
              >{{ title }}</TextBase
            >

            <ParagraphText size="text-base" class="mt-1">{{
              description
            }}</ParagraphText>
          </div>
          <div
            class="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6"
          >
            <ButtonBase size="md" href="/">Go back home</ButtonBase>
            <ButtonBase
              size="md"
              color="secondary"
              external
              href="mailto:info@jetphix.com?subject=I received an error in AirSchedule"
              >Contact Support</ButtonBase
            >
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import ParagraphText from '@/Common/Text/ParagraphText.vue'
import TextBase from '@/Common/Text/TextBase.vue'
import { computed } from 'vue'
import ButtonBase from '@/Common/Elements/Buttons/ButtonBase.vue'

const props = defineProps({
  status: Number,
})

const title = computed(() => {
  return {
    503: 'Service Unavailable',
    500: 'Server Error',
    404: 'Page Not Found',
    403: 'Forbidden',
  }[props.status]
})

const description = computed(() => {
  return {
    503: 'Sorry, we are doing some maintenance. Please check back soon.',
    500: 'Whoops, something went wrong on our servers.',
    404: 'Sorry, the page you are looking for could not be found.',
    403: 'Sorry, you are forbidden from accessing this page.',
  }[props.status]
})
</script>
